/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import { ORIENTATION, FILL } from './constants';
export var getTabId = function getTabId(uid, key) {
  return "tabs-".concat(uid, "-tab-").concat(key);
};
export var getTabPanelId = function getTabPanelId(uid, key) {
  return "tabs-".concat(uid, "-tabpanel-").concat(key);
};
export var isHorizontal = function isHorizontal(orientation) {
  return orientation === ORIENTATION.horizontal;
};
export var isVertical = function isVertical(orientation) {
  return orientation === ORIENTATION.vertical;
};
export var isRTL = function isRTL(direction) {
  return direction === 'rtl';
};
export var isIntrinsic = function isIntrinsic(fill) {
  return fill === FILL.intrinsic;
};
export var isFixed = function isFixed(fill) {
  return fill === FILL.fixed;
};